import { Link } from "react-router-dom";

const IMG_HERO = "https://static.prod-images.emergentagent.com/jobs/61f75580-40da-4cae-8d9a-49fb6b0c2bbd/images/466bbda6acceeec539fe277ce33c965a5d36e04cdbf2a737239ec2963efd842d.png";

export default function About() {
  return (
    <div data-testid="about-page">
      <section className="grid lg:grid-cols-2">
        <div className="order-2 lg:order-1 flex items-center px-6 lg:px-16 py-16 bg-ivory">
          <div className="max-w-xl">
            <p className="small-label text-gold">Our story</p>
            <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl mt-4 leading-[1.05]">
              Affordable luxury, for the modern South African woman.
            </h1>
            <p className="text-stone mt-6 leading-relaxed">
              Maison Luxe was founded in Johannesburg with a single ambition – to give every woman access to salon-quality
              wigs without the salon ceremony. Each piece is hand-finished, pre-styled and quality-checked in our studio
              before it travels to your door.
            </p>
            <p className="text-stone mt-4 leading-relaxed">
              We believe wigs are an extension of confidence. Whether you're protecting your natural hair, switching up
              your look, or just having fun – you deserve a wig that feels couture, not costume.
            </p>
            <Link to="/shop" className="btn-primary mt-9">Discover the edit</Link>
          </div>
        </div>
        <div className="order-1 lg:order-2 relative min-h-[60vh]">
          <img src={IMG_HERO} alt="Studio" className="absolute inset-0 w-full h-full object-cover" />
        </div>
      </section>

      <section className="bg-nude">
        <div className="max-w-7xl mx-auto px-6 py-24 grid md:grid-cols-3 gap-10 text-center">
          {[
            { n: "01", t: "Premium Quality", b: "100% human hair and HD lace from ethically sourced vendors." },
            { n: "02", t: "Hand-Finished", b: "Every wig is plucked, bleached and styled before it ships." },
            { n: "03", t: "Beginner Friendly", b: "Pre-cut lace, pre-styled curls, elastic bands. No skill required." },
          ].map((b) => (
            <div key={b.n}>
              <p className="font-serif text-3xl text-gold">{b.n}</p>
              <p className="font-serif text-xl mt-3">{b.t}</p>
              <p className="text-stone text-sm mt-2 leading-relaxed">{b.b}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="max-w-4xl mx-auto px-6 py-24 text-center">
        <p className="small-label text-gold">Promise</p>
        <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl mt-4 leading-tight">
          "Salon quality, without the salon pricing."
        </h2>
        <p className="text-stone mt-6">Trusted by thousands of women across South Africa.</p>
      </section>
    </div>
  );
}
